module.exports = __webpack_public_path__ + "img/logo4.63c31fc4.png";